import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ProjectsService } from '../../../../../../core/projects.service';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../state/app.state';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../../../../../shared/components';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { DeleteCIWRRequest } from '../../../../../../core/projects.actions';

@Component({
    selector: 'app-change-in-work-request-side-nav-wrapper',
    templateUrl: './change-in-work-request-side-nav-wrapper.component.html',
    styleUrls: ['./change-in-work-request-side-nav-wrapper.component.scss'],
    standalone: false
})
export class ChangeInWorkRequestSideNavWrapperComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('tabGroup') tabs: MatTabGroup;
  @Input() data;
  createRequest = false;
  selectedTabIndex = 0;
  tabIndexMap = {
    details: 0,
    workflow: 1,
  };
  projectId: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    public projectsService: ProjectsService,
    public route: ActivatedRoute,
    public router: Router,
    private store: Store<fromRoot.State>,
    public dialog: MatDialog,
  ) {

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp?.snsubTab) {
          this.selectedTabIndex = this.tabIndexMap[qp?.snSubTab] || 0;
        }
      });
  }

  ngOnInit() {
    this.projectsService.createRequest
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.data = data.data;
        this.createRequest = data.type;
      });

    this.createRequest = !!this.data.createRequest;
  }

  ngAfterViewInit() {
  }

  onTabChange(event: MatTabChangeEvent) {
    const label = event.tab.textLabel.toLowerCase().replace(/\s+/g, '-');
    this.router.navigate([], {
      queryParams: { snSubTab: label },
      queryParamsHandling: 'merge',
    });
  }

  deleteCIWR(data) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: new ConfirmDialogModel(
        'Delete',
        `Are you sure you want to delete?`,
      ),
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const payload = {
          id: data.id,
          projectId: data?.project?.id,
        };
        this.store.dispatch(DeleteCIWRRequest({ payload }));
        this.projectsService.isAnyFormDirty.next(false);
      }
    });


  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
